import { render, staticRenderFns } from "./BtChart.vue?vue&type=template&id=4a6bc659&scoped=true&"
import script from "./BtChart.vue?vue&type=script&lang=js&"
export * from "./BtChart.vue?vue&type=script&lang=js&"
import style0 from "./BtChart.vue?vue&type=style&index=0&id=4a6bc659&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6bc659",
  null
  
)

export default component.exports